"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _formatMessage = _interopRequireDefault(require("format-message"));

var _translations = _interopRequireDefault(require("./translations.json"));

var _underscored_crc = _interopRequireDefault(require("format-message-generate-id/underscored_crc32"));

const ns = _formatMessage.default.namespace();

ns.setup({
  translations: _translations.default,
  generateId: _underscored_crc.default
});
var _default = ns;
exports.default = _default;